import { render } from "./clear-cache.vue?vue&type=template&id=353584b0"
import script from "./clear-cache.vue?vue&type=script&lang=js"
export * from "./clear-cache.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__